const keyIsSet = (item) => item === 0 || !!item;

export default (key, order = 'ASC') => {
  switch (order) {
    case 'DESC':
      return (a, b) => (keyIsSet(a[key]) && keyIsSet(b[key]) ? b[key] - a[key] : 0);
    case 'ASC':
    default:
      return (a, b) => (keyIsSet(a[key]) && keyIsSet(b[key]) ? a[key] - b[key] : 0);
  }
};
